export default {
  'menu.users': '用户中心',
  'pages.users.action.detail': '详情',
  'pages.users.action.refresh': '刷新',
  'pages.users.column.action': '操作',
  'pages.users.column.amBitId': 'AmBit ID',
  'pages.users.column.createdAt': '注册时间',
  'pages.users.column.displayId': '展示 ID',
  'pages.users.column.gender': '性别',
  'pages.users.column.nickname': '昵称',
  'pages.users.column.region': '地区',
  'pages.users.column.showId': 'Show ID',
  'pages.users.column.status': '状态',
  'pages.users.column.tier': '等级别名',
  'pages.users.column.timStatus': 'TIM 状态',
  'pages.users.column.uid': 'UID',
  'pages.users.column.updatedAt': '更新时间',
  'pages.users.column.userId': '用户 ID',
  'pages.users.column.vipLevel': 'VIP 等级',
  'pages.users.detail.field.accountStatus': '账号状态',
  'pages.users.detail.field.agentAtName': '代理 @ 名称',
  'pages.users.detail.field.amBitId': 'AmBit ID',
  'pages.users.detail.field.avatarUrl': '头像 URL',
  'pages.users.detail.field.bio': '个人简介',
  'pages.users.detail.field.birthday': '生日',
  'pages.users.detail.field.c2cMuteSeconds': '单聊禁言秒数',
  'pages.users.detail.field.complaintCount': '投诉次数',
  'pages.users.detail.field.createdAt': '创建时间',
  'pages.users.detail.field.did': 'DID',
  'pages.users.detail.field.gender': '性别',
  'pages.users.detail.field.groupMuteSeconds': '群聊禁言秒数',
  'pages.users.detail.field.identityId': '身份 ID',
  'pages.users.detail.field.nickname': '昵称',
  'pages.users.detail.field.onlineStatus': '在线状态',
  'pages.users.detail.field.pushId': '推送 ID',
  'pages.users.detail.field.region': '地区',
  'pages.users.detail.field.reportedCount': '被投诉次数',
  'pages.users.detail.field.showId': '展示 ID',
  'pages.users.detail.field.status': '状态',
  'pages.users.detail.field.timStatus': 'TIM 状态',
  'pages.users.detail.field.tmId': 'TM ID',
  'pages.users.detail.field.trtcId': 'TRTC ID',
  'pages.users.detail.field.updatedAt': '更新时间',
  'pages.users.detail.field.userId': '用户 ID',
  'pages.users.detail.field.vipLevel': 'VIP 等级',
  'pages.users.detail.field.wId': 'W ID',
  'pages.users.detail.profile': '用户详情',
  'pages.users.detail.risk': '风险数据',
  'pages.users.detail.tim': 'TIM 数据',
  'pages.users.detail.timMute': 'TIM 禁言',
  'pages.users.detail.timStatus': 'TIM 状态',
  'pages.users.detail.title': '用户详情：{uid}',
  'pages.users.empty.detail': '暂无数据',
  'pages.users.gender.female': '女',
  'pages.users.gender.male': '男',
  'pages.users.gender.unknown': '未知',
  'pages.users.message.missingUid': '缺少用户 UID',
  'pages.users.search.compatSearch': '兼容搜索',
  'pages.users.search.createdRange': '注册时间',
  'pages.users.search.isBanned': '封禁状态',
  'pages.users.search.keyword': '关键词',
  'pages.users.search.sort': '排序',
  'pages.users.search.status': '用户状态',
  'pages.users.search.tier': '等级别名',
  'pages.users.search.timStatus': 'TIM 状态',
  'pages.users.search.vipLevel': 'VIP 等级',
  'pages.users.sort.createdAsc': '注册时间升序',
  'pages.users.sort.createdDesc': '注册时间降序',
  'pages.users.sort.updatedDesc': '更新时间降序',
  'pages.users.status.banned': '封禁',
  'pages.users.status.normal': '正常',
  'pages.users.timStatus.abnormal': '异常',
  'pages.users.timStatus.normal': '正常',
  'pages.users.title': '用户中心',
};
